/**
 * Created by zhusq on 2017/8/21.
 */


angular.module("DSSXAPP", ['app.core']);
angular.module("accountCenter", ["DSSXAPP"]);


angular
    .module("accountCenter")
    .controller('accountCtr', ['$rootScope', '$scope', '$q', 'request', function ($rootScope, $scope, $q, request) {
        $scope.oldPersonInfo = null; // 个人信息

        var vm = $scope;
        vm.d = {
            pwd: {
                oldPwd: null,
                newPwd: null,
                confirmPwd: null
            }

        };

        vm.f = {
            modifyPhone: modifyPhone,
            modifyPwd: modifyPwd
        };

        function initGetAccountNum() {
            var url = '/usr/api/listSubAccount';
            request.get(url, {}, true).then(success, error);

            function success(res) {
                res = res || {};
                var subAccountsList = res.data.subAccounts || [];
                $scope.subAccountCount = subAccountsList.length;
            }

            function error(err) {
                DSSX.dialog.err(err, {
                    moduleName: '账户中心',
                    funcName: 'initGetAccountNum',
                    text: 'initGetAccountNum fail'
                });
            }
        }

        initGetAccountNum();
        $scope.showFullAccountTip = function () {
            if ($scope.subAccountCount === 5) {
                layer.msg("子账号数量到达上限");
            }
        };

        var getHandler = new GetHandler();
        getHandler.url = "/usr/api/loadPerInfo?token=" + new TokenHelper("").getToken();
        getHandler.onSuccess = function (data) {
            $scope.oldPersonInfo = data.personalInfo || {}; // 保存原始信息
            $scope.$apply(function () {
                var inf = data.personalInfo || {};
                $scope.email = inf.email;
                $scope.avatarUrl = inf.photo || '';

                $scope.tel = formatTelPhone(inf.bindPhone);
            });
        };
        getHandler.onError = function (json, msg, error) {
            DSSX.dialog.err(error, {
                moduleName: '账户中心',
                funcName: 'getHandler',
                text: '加载个人信息失败'
            });
        };
        getHandler.start();

        var lId;
        $scope.changeEmial = function () {
            $scope.tEmail = "";
            $scope.agEmail = "";
            lId = layer.open({
                type: 1,
                title: '修改邮箱',
                area: ['300px', '180px'],
                closeBtn: 1,
                shadeClose: false,
                content: $("#email_dlg")
            });
        };
        $scope.onEmailSubmit = function () {
            if ($("#email_dlg.ng-invalid-required").length > 0) {
                layer.msg("请填写邮箱", {icon: 2});
                return;
            }
            if ($("#email_dlg.ng-invalid-email").length > 0) {
                layer.msg("邮箱格式不正确", {icon: 2});
                return;
            }
            if ($scope.tEmail != $scope.agEmail) {
                layer.msg("两次邮箱不一致", {icon: 2});
                return;
            }

            var loaderId = layer.load(2, {shade: 0.2});
            request
                .post('/usr/api/updatePerInfo', null, {email: $scope.agEmail}, true)
                .then(function () {
                    $scope.email = $scope.agEmail;

                    layer.close(lId);
                    layer.msg("修改成功", {icon: 1});
                }, function (error) {
                    if (5 === error.data.data.code) {
                        console.log('[account-center] onEmailSubmit_updatePerInfo: Update Mailing Information failed', error);
                        layer.msg("该邮箱已被其他用户使用", {icon: 5});
                        return;
                    }

                    DSSX.dialog.err(error, {
                        moduleName: '账户中心',
                        funcName: 'onEmailSubmit',
                        text: '修改邮箱失败',
                    });
                })
                .finally(function () {
                    layer.close(loaderId);
                });

        };

        // ======================modify phone=================================
        function modifyPhone() {
            console.log('modify phone init:');
            modifyTel(modifyTelPhone);
        }

        function modifyTelPhone(newTel, lIndex) {
            var url = '/usr/api/updatePerInfo';
            request.post(url, {}, {bindPhone: newTel}, true).then(success, error);

            function success(res) {
                $scope.tel = formatTelPhone(newTel);
                layer.close(lIndex);
                layer.msg("修改成功", {icon: 1});
            }

            function error(err) {
                DSSX.dialog.err(err, {
                    moduleName: '账户中心',
                    funcName: 'modifyTelPhone',
                    text: 'modifyTelPhone fail'
                });
            }
        }

        function formatTelPhone(tel) {
            tel = tel || '';
            $scope.bindTelTip = "修改手机";
            if (tel.length === 0) {
                $scope.bindTelTip = "绑定手机";
                return tel;
            }
            var telPhone = tel.slice(-4);
            telPhone = '*******' + telPhone;
            return telPhone;
        }

        function modifyPwd() {
            vm.d.pwd.oldPwd = vm.d.pwd.newPwd = vm.d.pwd.confirmPwd = "";
            console.log('modify password init:');
            var index = layer.open({
                type: 1,
                title: '修改密码',
                content: $('.modify-pwd-box'),
                area: ['500px', '270px'],
                btn: ['确定'],
                yes: function () {
                    var checkResult = checkPassword([vm.d.pwd.oldPwd, vm.d.pwd.newPwd, vm.d.pwd.confirmPwd]);
                    if (!checkResult.result) {
                        layer.alert(checkResult.message);
                    } else {
                        modifyPassword();
                    }

                    function checkPassword(pwd) {
                        pwd = pwd || [];
                        var errMsg = {
                            result: true,
                            message: ''
                        };
                        for (var i = 0; i < 3; i += 1) {
                            if (!pwd[i]) {
                                errMsg = {
                                    result: false,
                                    message: '必须输入密码'
                                };
                                return errMsg;
                            }
                        }
                        for (var i = 0; i < 3; i += 1) {
                            if (pwd[i].length < 6) {
                                errMsg = {
                                    result: false,
                                    message: '密码长度大于等于6个字符'
                                };
                                return errMsg;
                            }
                        }
                        if (errMsg.result && (vm.d.pwd.newPwd !== vm.d.pwd.confirmPwd)) {
                            errMsg = {
                                result: false,
                                message: '两次密码不一致'
                            };
                            return errMsg;
                        }
                        return errMsg;
                    }

                    function modifyPassword() {
                        var url = '/usr/api/updatePerInfo';
                        request.post(url, {}, {secret: vm.d.pwd.newPwd}, true).then(success, error);

                        function success(res) {
                            layer.close(index);
                            layer.msg("修改成功", {icon: 1});
                        }

                        function error(err) {
                            DSSX.dialog.err(err, {
                                moduleName: '账户中心',
                                funcName: 'modifyPassword',
                                text: 'modifyPassword fail'
                            });
                        }
                    }
                }

            })
        }

        function modifyTel(onOk) {
            var dlg = '' +
                '<div>\
                    <style>\
                        .box{\
                                font-size: 12px;\
                                padding-top: 25px;\
                                padding-left: 80px;\
                            }\
                        .item>input {\
                                width: 200px;\
                                height: 26px;\
                                border-radius: 3px;\
                                border: 1px solid #999;\
                            }\
                         .item{\
                                margin-top:10px;\
                            }\
                        .item>span {\
                                display: inline-block;\
                                width: 70px;\
                                text-align: justify;\
                            }\
                    </style>\
                    <div class="box">\
                        <div class="item"><span>新号码:</span><input></div>\
                        <div class="item"><span>确认号码:</span><input></div>\
                    </div>\
                </div>';

            var rid = Math.ceil(Math.random() * 100);
            dlg = dlg.replace(/item/g, 'item' + rid);
            dlg = dlg.replace(/box/g, 'box' + rid);

            var qDlg = $(dlg);
            $("body").append(qDlg);

            var telArr = qDlg.find("input");

            //return errMsg
            function checkTel() {
                var tel1 = telArr[0].value;
                var tel2 = telArr[1].value;
                if (!tel1 || !tel2) {
                    return "请输入手机";
                }
                if (tel1 !== tel2) {
                    return "两次手机号不一致";
                }
                var reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
                if (!reg.test(tel1) || !reg.test(tel2)) {
                    return "手机格式不正确"
                }
            }

            var lIndex = layer.open({
                type: 1,
                title: '修改手机',
                content: qDlg,
                area: ['500px', '270px'],
                btn: ['确定'],
                yes: function () {
                    var err = checkTel();
                    if (err) {
                        layer.msg(err);
                        return;
                    }
                    if (onOk) {
                        onOk(telArr[0].value, lIndex);
                    }
                },
                end: function () {
                    qDlg.remove();
                }
            })
        }

    }]);
